import { SeekButton as SeekButton$1 } from "../../../../../ui/seek-button/component.js";
import ForwardRef from "../../../../../icons/dist/react/minimal/seek.js";
import { Button } from "../../../shared/components/buttons/button.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/minimal-audio/components/buttons/seek-button.tsx
/** @jsxImportSource react */
function SeekButton({ className, seconds = 10, ...props } = {}) {
	return /* @__PURE__ */ jsx(SeekButton$1, {
		render: /* @__PURE__ */ jsx(Button, {}),
		className: (state) => cn("media-seek-button", resolveClassName(className, state)),
		seconds,
		...props,
		children: /* @__PURE__ */ jsxs("div", {
			className: "media-seek-button-content",
			children: [/* @__PURE__ */ jsx(ForwardRef, { className: cn("media-button-icon", seconds < 0 && "media-seek-button-backward-icon") }), /* @__PURE__ */ jsx("span", {
				className: cn("media-seek-button-label", seconds < 0 ? "media-seek-button-backward-label" : "media-seek-button-forward-label"),
				children: Math.abs(seconds)
			})]
		})
	});
}
//#endregion
export { SeekButton };

//# sourceMappingURL=seek-button.js.map